import { parseFormattedTime } from "../common";
import { VideoPlayer } from "./videoPlayer";

declare global {
    interface Window {
        requestSync: () => void;
        requestSyncFunction: (functionName: string) => void;
        clearSync: () => void;
        setTimeIn: (value: string) => void;
        setTimeOut: (value: string) => void;
        jumpToTimecode: (timecode: string) => void;
        playerStop: () => void;
        selectTimes: (timeIn: string, timeOut: string) => void;
    }
}

export const registerWindowApi = (player: VideoPlayer) => {
    window.requestSync = () => player.syncPayload();
    window.requestSyncFunction = (functionName: string) =>
        player.syncPayload(functionName);
    window.clearSync = () => player.clearTimes();
    window.setTimeIn = (value: string) => player.setTimeIn(value);
    window.setTimeOut = (value: string) => player.setTimeOut(value);
    window.jumpToTimecode = (timecode: string) => {
        player.currentTime = parseFormattedTime(timecode);
    };
    window.playerStop = () => player.pause();

    window.selectTimes = (timeIn: string, timeOut: string) => {
        player.timeIn = parseFormattedTime(timeIn);
        player.timeOut = parseFormattedTime(timeOut);
        player.syncPayload();
    };
};
